import React, { Component } from 'react';
import { Col } from 'antd';
import { observer, inject } from 'mobx-react';
import { Modal } from 'antd-mobile';

const confirmAlert = Modal.alert;

@inject(
  'templateStore',
  'CmsLanguageStore',
  'webSettingStore',
  'CmsMenuStore'
)
@observer
class HomeFooterThemeTwo extends Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }

  componentDidMount() {
  }

  menuSoonClick = () => {
    const { activeTemplate } = this.props.templateStore;
    const { data: webSetting } = this.props.webSettingStore;
    confirmAlert('',
      <div
        style={{
          fontFamily: activeTemplate.templateSetting.text.fontFamily,
          color: activeTemplate.templateSetting.text.color,
          fontSize: activeTemplate.templateSetting.text.fontSize,
          lineHeight: `${activeTemplate.templateSetting.text.fontSize + 6}px`,
          textAlign: 'center'
        }}
      >
        <span>Available Soon</span>
      </div>,
      [
        {
          text: webSetting.okText
        }
      ]);
  }

  menuTileOnClick = (page) => {
    this.props.history.push(page);
  }

  menuClick = (taskID, menuType, isSoon, redirectUrl) => {
    const {
      activeLanguages
    } = this.props.CmsLanguageStore;

    const lang = window.localStorage.getItem('lang') || 'en';
    let languageId = 1;
    if (lang && activeLanguages.length > 0) {
      const language = activeLanguages.find(fi => fi.code === lang);
      if (language) {
        languageId = activeLanguages.find(fi => fi.code === lang).id;
      }
    }

    if (isSoon) {
      this.menuSoonClick();
    } else {
      switch (menuType) {
        case 'AMENITY':
          this.props.history.push(`amenity`);
          break;

        case 'HK_SERVICE':
        case 'CONCIERGE':
        case 'DEFECT_REPORT':
        case 'DND':
        case 'FRONT_OFFICE':
        case 'LATE_CHECKOUT':
          this.props.history.push(`single-list/${taskID}/language/${languageId}`);
          break;

        case 'BOOKING_FACILITY':
          this.props.history.push(`booking`);
          break;

        case 'IN_ROOM_DINING':
          this.props.history.push(`fnb`);
          break;

        case 'IN_ROOM_DINING_URL':
          if (redirectUrl) {
            window.open(redirectUrl, '_blank');
          } else {
            console.warn('Redirect URL is not configured for this menu');
          }
          break;

        case 'LAUNDRY':
          this.props.history.push(`laundry`);
          break;

        case 'PRINT_FILE':
          this.props.history.push(`print-file`);
          break;

        case 'SHOPPING':
          this.props.history.push(`shopping`);
          break;

        case 'SPA':
          this.props.history.push(`spa`);
          break;

        case 'TRANSPORTATION':
          this.props.history.push(`transportation`);
          break;

        case 'TV_CHANNEL':
          this.props.history.push(`tv-channel`);
          break;

        case 'WAKE_UP_CALL':
          this.props.history.push(`wakeup-call`);
          break;

        default:
          break;
      }
    }
  }

  render() {
    const { activeTemplate } = this.props.templateStore;
    const { data: webSetting } = this.props.webSettingStore;
    const { data: activeMenus } = this.props.CmsMenuStore;
    const lang = window.localStorage.getItem('lang') || 'en';
    const { activeLanguages } = this.props.CmsLanguageStore;

    let languageId = 1;
    if (lang && activeLanguages.length > 0) {
      const language = activeLanguages.find(fi => fi.code === lang);
      if (language) {
        languageId = activeLanguages.find(fi => fi.code === lang).id;
      }
    }

    return (
      <>
        {
          activeTemplate
            ?
            <>
              {
                webSetting
                  ?
                  <Col span={24} className='stm-home-theme-two-footer-container'>
                    <div className='stm-home-theme-two-footer'>
                      <div className='stm-home-theme-two-grid-container stm-home-theme-two-footer-grid-container'>
                        <div className='stm-home-theme-two-footer-grid'>
                          <div className='stm-home-theme-two-footer-item'>
                            <div className='stm-home-theme-two-footer-item-icon'>
                              <img src={require('../../assets/TemplateTwo/Images/Icons/HomeSelected.svg')} alt='Logo' className='stm-home-theme-two-footer-img-item' />
                            </div>
                            <div className='stm-home-theme-two-footer-item-name'>
                              <span
                                style={{
                                  fontFamily: activeTemplate.templateSetting.menu.fontFamily,
                                  color: activeTemplate.templateSetting.menu.color,
                                  fontSize: activeTemplate.templateSetting.menu.fontSize,
                                  lineHeight: `${activeTemplate.templateSetting.menu.fontSize + 6}px`
                                }}
                              >{webSetting.homeText}</span>
                            </div>
                          </div>

                          {/* Active Menus */}
                          <>
                            {
                              activeMenus.map(menu => {
                                return (
                                  menu.menuType !== 'IN_ROOM_DINING' &&
                                    menu.menuType !== 'SHOPPING' &&
                                    menu.menuType !== 'LAUNDRY' &&
                                    menu.menuType !== 'SPA' &&
                                    menu.menuType !== 'BOOKING_FACILITY'
                                    ?
                                    <div className='stm-home-theme-two-footer-item' onClick={() => this.menuClick(menu.taskID, menu.menuType, menu.isSoon, menu.redirectUrl)}>
                                      <div className='stm-home-theme-two-footer-item-icon'>
                                        <img src={menu.imageUrl} alt='Logo' className='stm-home-theme-two-footer-img-item' />
                                      </div>
                                      <div className='stm-home-theme-two-footer-item-name'>
                                        <span
                                          style={{
                                            fontFamily: activeTemplate.templateSetting.menu.fontFamily,
                                            color: activeTemplate.templateSetting.menu.color,
                                            fontSize: activeTemplate.templateSetting.menu.fontSize,
                                            lineHeight: `${activeTemplate.templateSetting.menu.fontSize + 6}px`
                                          }}
                                        >{menu.taskLanguages.find(fi => fi.langID === languageId).taskLangName}</span>
                                      </div>
                                    </div>
                                    :
                                    null
                                )
                              })
                            }
                          </>

                          <div className='stm-home-theme-two-footer-item' onClick={() => this.menuTileOnClick('order')}>
                            <div className='stm-home-theme-two-footer-item-icon'>
                              <img src={require('../../assets/TemplateTwo/Images/Icons/Order.svg')} alt='Logo' className='stm-home-theme-two-footer-img-item' />
                            </div>
                            <div className='stm-home-theme-two-footer-item-name'>
                              <span
                                style={{
                                  fontFamily: activeTemplate.templateSetting.menu.fontFamily,
                                  color: activeTemplate.templateSetting.menu.color,
                                  fontSize: activeTemplate.templateSetting.menu.fontSize,
                                  lineHeight: `${activeTemplate.templateSetting.menu.fontSize + 6}px`
                                }}
                              >{webSetting.orderText}</span>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </Col>
                  :
                  null
              }
            </>
            :
            null
        }
      </>
    )
  }
}

export default HomeFooterThemeTwo;